/**
 * Text used in the certification info page.
 */
export const CertificationInfoMessages = {
    /**
     * Hover hint on the section header "Signature."
     */
    signatureSection:
        'Information in fields 60 & 61 constitutes your electronic signature and date to be provided to the FCC.',

    /**
     * Footer text at the bottom of the screen.
     */
    footer: ` <p class="text-xs text-tertiary-800">
                FAILURE TO SIGN THIS APPLICATION MAY RESULT IN DISMISSAL OF THE
                APPLICATION AND FORFEITURE OF ANY FEES PAID.
            </p>
            <p class="text-xs text-tertiary-800">
                Upon grant of this license application, the Licensee may be subject
                to certain construction or coverage requirements. Failure to meet
                the construction or coverage requirements will result in termination
                of the license. Consult appropriate FCC regulations to determine the
                construction or coverage requirements that apply to the type of
                license requested in this application.
            </p>
            <p class="text-xs text-tertiary-800">
                WILLFUL FALSE STATEMENTS MADE ON THIS FORM OR ANY ATTACHMENTS ARE
                PUNISHABLE BY FINE AND/OR IMPRISONMENT (U.S. Code, Title 18, §1001)
                AND/OR REVOCATION OF ANY STATION LICENSE OR CONSTRUCTION PERMIT
                (U.S. Code, Title 47, §312(a)(1)), AND/OR FORFEITURE (U.S. Code,
                Title 47, §503).
            </p>`,
};
